import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

export const UniversalCreatePublisherModalLoader = () =>
  import(/* webpackChunkName: "4-feat-universal-create-publisher" */ './UniversalCreatePublisherModal');

export default lazyLoadOnRender({ loader: UniversalCreatePublisherModalLoader });
